export default class CatalogFolderModel {
    constructor(data = {}) {
        this.id = data.id;
        this.name = data.name;
    }
}
